import { Component, Input } from '@angular/core';

export type AlertType = 'info' | 'success' | 'warning' | 'error' | 'common';

@Component({
  selector: 'fl-alert',
  template: `
    <div class="AlertBox"
      flLayout
      flLayoutGap="xxsmall"
      flLayoutAlign="start baseline"
      [attr.data-type]="type"
    >
      <div>
        <ng-content select="fl-icon"></ng-content>
      </div>
      <div flLayoutFlex="grow">
        <ng-content></ng-content>
      </div>
      <fl-button *ngIf="closeable">
        <fl-icon name="ui-close" color="dark" size="small"></fl-icon>
      </fl-button>
    </div>
  `,
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  @Input() type: AlertType = 'common';
  @Input() closeable = true;
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/app/@shared/ui/alert/alert.component.ts